import { env } from "@/config/env";

/** Other-org `#/demo` docs. On in bartik only (`VITE_ENABLE_DEMO_DOCS`). */
export function isDemoDocsEnabled(): boolean {
  return env.enableDemoDocs;
}
